<div style="text-align: center; border-style: solid; border-color: coral;margin-bottom: 15px;">
  <span style="color: blue">
    Responvável vigente: {{mensagemResponsavelVigente}}
  </span>
</div>

<mat-accordion>

  <mat-expansion-panel [expanded]="openFormCadastro"
                       (closed)="openFormCadastro = false">
    <mat-expansion-panel-header>
      <mat-panel-title>
        Responsábilidade
      </mat-panel-title>
    </mat-expansion-panel-header>

    <cadastrar-responsavel #cadastrarResponsavel
                           [familiar]="familiar">
    </cadastrar-responsavel>
  </mat-expansion-panel>


  <mat-expansion-panel [expanded]="!openFormCadastro"
                       (opened)="listaResponsaveis.carregarListaResponsaveis()"
                       (closed)="openFormCadastro = true">
    <mat-expansion-panel-header>
      <mat-panel-title>
        Períodos como responsável ( {{familiar.responsaveis.length}} )
      </mat-panel-title>
    </mat-expansion-panel-header>

    <lista-responsaveis #listaResponsaveis
                        [familiar]="familiar"
                        (onResponsavel)="onGetAdicionar($event); cadastrarResponsavel.carregarResponsavel($event)"
                        (onAdicionar)="onGetAdicionar($event); cadastrarResponsavel.initObjetos()">
    </lista-responsaveis>

  </mat-expansion-panel>

</mat-accordion>
